import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import 'webix/photo'; // Importing photo module from webix
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the FilterPagoPremioView.
 * @extends JetView
 */
export default class FilterPagoPremioView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for ticket number
                            name: 'NoTicket',
                            id: 'NoTicket',
                            type: 'number',
                            label: "<span class='icon-ticket'></span>" + _('Id premio'),
                            labelPosition: 'top',
                            placeholder: _('Id premio'),
                            required: true,
                            invalidMessage: _('Campo Requerido'), // Validation message
                        },
                        {
                            view: 'text', // Text input for ticket password
                            name: 'ClaveTicket',
                            id: 'ClaveTicket',
                            label: "<span class='icon-ticket1'></span>" + _('Contraseña'),
                            labelPosition: 'top',
                            placeholder: _('Contraseña'),
                            required: true,
                            invalidMessage: _('Campo Requerido'), // Validation message
                            attributes: {
                                autocomplete: 'new-password', // Prevents autocomplete
                            },
                        },
                        { id: 'grav5', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: screen == 'small' ? 130 : 0, // Conditional height based on screen size
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing inputs
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav4', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the form
                                $$('formPagoPremio').hide(); // Hides the form
                                $$('toolbar').hide(); // Hides the toolbar
                                $$('tablePagoPremio').hide(); // Hides the table
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            hotkey: 'enter', // Enter key triggers this button
                            click: () => {
                                if (this.getRoot().validate()) {
                                    // Validates the form
                                    const filterdata = this.getRoot().getValues(); // Gets form values
                                    this.app.callEvent('pagoPremio:filter', [filterdata]); // Calls filter event
                                    const vthis = this; // Reference to the current context
                                    webix.ajax().get(
                                        devConfig.geturlApi() + 'UserManagement/GetPrizesLoyalty', // API endpoint
                                        'Id=' + filterdata.NoTicket + '&Password=' + filterdata.ClaveTicket, // Query parameters
                                        {
                                            error: function () {
                                                webix.message('Error! '); // Error message
                                            },
                                            success: function (text) {
                                                text = JSON.parse(text); // Parses the response
                                                if (text.HasError) {
                                                    webix.message({
                                                        title: '¡Error!',
                                                        type: 'alert-error',
                                                        text: _('Ticket no encontrado'), // Error message for not found ticket
                                                    });
                                                } else {
                                                    vthis.app.callEvent('pagoPremio:data', [text.data[0]]); // Calls data event with response
                                                    $$('FilterPagoPremio').hide(); // Hides the filter view
                                                    $$('formPagoPremio').show(); // Shows the form
                                                    $$('back-button').show(); // Shows the back button
                                                    if (text.data[0].State != 'R') {
                                                        $$('ButtonPagarPremio').hide(); // Hides pay button if state is not 'R'
                                                    }
                                                }
                                            },
                                        },
                                    );
                                }
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form', // Main view type
            id: 'FilterPagoPremio', // Unique identifier for the form
            rows: [upper_section, buttons], // Layout structure
            elementsConfig: {
                on: {
                    onChange: function (newv, oldv) {
                        this.validate(); // Validates on change
                        $$('NoTicket').define('inputHeight', 38); // Sets input height
                        $$('NoTicket').refresh(); // Refreshes the input
                        $$('ClaveTicket').define('inputHeight', 38); // Sets input height
                        $$('ClaveTicket').refresh(); // Refreshes the input
                    },
                },
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav4').hide(); // Hides element for small screens
                $$('grav5').hide(); // Hides element for small screens
            }
        });
    }
}

// FILE DOCUMENTED
